module.exports = __webpack_public_path__ + "img/162005.da3d8e59.jpg";